$("html").removeClass("js_disabled")
$("html").addClass("js_enabled")



$(".icon-with-text__item").click(function() {

    $('html, body').animate({
        scrollTop: parseInt($(".scroll-to").offset().top)
    }, 2000);
});


//REPOSITION THE STORE LOCATOR BREADCRUMB
if($(".directory-breadcrumbs").length > 0){
  var li = '<li class="icon"><svg width="10" height="0" class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></li>'  
  $(".breadcrumbs").append($(".directory-breadcrumbs"))
  $(".page-wrapper .directory-breadcrumbs").remove()   
  $(".breadcrumb-seperator").remove()
  $(".breadcrumbs").find("li.icon").remove()
  $(".breadcrumb-item").unwrap()
  $(".breadcrumbs").find("li").removeClass("final")
  $(".breadcrumb-item").wrap("<li class='locator'></li>")  
  $(".breadcrumbs").find("li:not(:last-child)").after(li)
  $(".breadcrumbs").find("li:last-child").addClass("final")
}
$( ".breadcrumbs" ).each(function( index ) {
  var text = $(this).find("li.final").text()
  $(this).find("li.final").replaceWith("<li class='final'>"+text+"</li>");
})



$(".tooltippy").hover(function(){
    $(this).find(".tip-text").append($(this).attr("color"))    
    $(this).find(".tip-text").addClass("active")
    }, function(){
    $(this).find(".tip-text").contents().filter(function(){
      return this.nodeType === 3;
    }).remove();
    $(this).find(".tip-text").removeClass("active")
  });


function isTouchPointer() {
  return matchMedia("(pointer: coarse)").matches;
}

const testElement = document.getElementById("media-query-test-target");

if(isTouchPointer()) {
  $("body").addClass("touch-enabled")
  console.log("This is most likely a touch device")
} else {
  $("body").removeClass("touch-enabled")
  console.log("This is not a touch device")
}


if($("h1.product-hero__title").length==1 && $(".shopify-policy__title").length==1){
   $(".shopify-policy__title").remove()
}else{
  $(".shopify-policy__title").show()
}

$(".accordionize-full-open-first").accordion({
    disabled: false,
    collapsible: true,
    active: 0,		
    heightStyle: "content",
    icons: false
  });	

$(".accordionize-tab").accordion({
    disabled: false,
    collapsible: true,
    active: false,		
    heightStyle: "content",
    icons: false
  });	

$(".accordionize_desktop").accordion({
  disabled: false,
  collapsible: true,
  header: "h4",
  active: false,
  icons: false
});


$('.accordionize_desktop').last().addClass('last');

/*ADD ACCORDION FUNCTION TO FOOTER MENU WHEN LESS THAN 992PX*/
var docWidth = window.innerWidth;
if(docWidth <= 990){

  $(".footer-block.brand_information").clone().insertAfter("div.subscribe_newsletter ").addClass("cloned");
  $(".footer-block.brand_information.cloned").find(".footer-block-image").remove()
  $( ".accordionize").accordion({
    disabled: false,
    collapsible: true,
    active: false,
   });
}

widthMatch = window.matchMedia("(max-width: 989px)");

widthMatch.addEventListener('change', function(mm) {
    if (mm.matches) {   	
          $(".footer-block.brand_information").clone().insertAfter("div.subscribe_newsletter ").addClass("cloned");
          $(".footer-block.brand_information.cloned").find(".footer-block-image").remove()
		  $( ".accordionize").accordion({
          disabled: false,
      	  collapsible: true,
		  active: false		
	     });   	   
    }
    else {	
        $(".footer-block.brand_information.cloned").remove()
		$( ".accordionize").accordion({
        disabled: true,
      	collapsible: false,
		active: true		
	  });	      
      //$(".accordionize .ui-accordion-content").css({"display": "block", "height" : "auto"});
    }
});



$('.newsletter-form__field-wrapper').find(".field__input").focus(function() {
    $(this).closest(".field").addClass('focus');
});

$('.newsletter-form__field-wrapper').find(".field__input").blur(function() {
    $(this).closest(".field").removeClass('focus');
});



//CHANGE IMAGES IN GALLERY AND SLIDER DEPENDING ON SELECTED VARIANT

$("form[data-hide='true-extra']").on( "change", function() {  
  var chosenColor = $(".product-form__input input[type='radio']:checked").val() 
  $(".product__media-item.grid__item").each(function() {    
    if( $(this).attr("thumbnail-alt") == chosenColor ){       
      $(this).css("display", "block")
    }else{
      $(this).css("display", "none")
    }
  })   
} );



$("form[data-hide='true']").on( "change", function() { 
  var chosenColor = $(".product-form__input input[type='radio']:checked").val() 
      
  $(".product__media-item").each(function() {          
      if($(this).attr("thumbnail-alt") == chosenColor ){                 
        $(this).addClass("selected")
      }else{
        $(this).removeClass("selected")
      }         
  });
  
  $(".thumbnail-list__item").each(function() {
    if($(this).attr("thumbnail-alt") == chosenColor ){              
      $(this).css("display", "block")
    }else{
      $(this).css("display", "none")
    }
  }) 

});




$(document).ready(function() {
if($(".thumbnail-list" ).length > 0){
    
  function disableButton(){    
      clearTimeout($.data(this, 'scrollTimer'));
      $.data(this, 'scrollTimer', setTimeout(function() { 
      var ulWidth = $(".thumbnail-list").outerWidth()
      
      var uloffsetLeft = $(".thumbnail-list").offset().left
      var uloffsetRight = $(".thumbnail-list").offset().left + ulWidth
      var slide = $(".thumbnail-list__item:visible")
      var liCount = $(".thumbnail-list__item:visible").length-1
      var firstSlide = slide.eq(0)
      var lastSlide = slide.eq(10)      
      var firstSlideOffsetLeft = slide.eq(0).offset().left
      var lastSlideOffsetRight = slide.eq(liCount).offset().left         
      if(firstSlideOffsetLeft >= uloffsetLeft ){       
          $(".slider-button--prev").prop('disabled', 'disabled')  
      }else{ 
        $(".slider-button--prev").prop("disabled", false)
      }
      if(lastSlideOffsetRight <= uloffsetRight ){ 
          $(".slider-button--next").prop('disabled', 'disabled')  
      }else{
        $(".slider-button--next").prop("disabled", false)
      }      
        }, 250));       
    } 
    disableButton()    
  
    $("body").on("click", ".custom_swatch", function(){
      disableButton() 
    })  
    $(".thumbnail-list" ).on( "scroll", function() {
      disableButton()    
    })
}

})


function resize_tabs(tab, section, max_width){  
      var section = "-"+section
      var tab = tab+section;
      var tab_accordion = ".tab-accordion"+section
      var tab_animated = ".accordionize-tab-animated"+section  

   
      if(max_width == "true"){
        var values = [];
        $(".tabs").each(function(){
           var maxWidth = 0; 
          $(this).find("li.tab-li").each(function(){ 
              var margin = $(this).css("margin-right")
              maxWidth += $(this).outerWidth()+parseInt(margin)   
           })
          values.push(maxWidth);
        });     
        var element_width = Math.max.apply(Math,values);  
      }else{
        var element_width = 0;   
        $(tab).find("li").each(function(){
           var margin = $(this).css("margin-right")
          element_width += $(this).outerWidth()+parseInt(margin)
        })       
      }
  
      var resizeObserver = new ResizeObserver((entries) => {      
      var entry = entries[0]; 
      for (var entry of entries) {                
        if (entry.contentBoxSize) {
          var contentBoxSize = entry.contentBoxSize[0];            
          if(contentBoxSize.inlineSize <= element_width){ 
            $(tab).addClass("enable-fullwidth") 
            $(tab_accordion).addClass("invisible")
            $(tab_animated).removeClass("hidden")
          }else{      
             $(tab).removeClass("enable-fullwidth") 
            $(tab_accordion).removeClass("invisible")
            $(tab_animated).addClass("hidden")
          }    
        }
      }
    });    
    resizeObserver.observe(document.querySelector(tab));  
}





 $(".image-with-text-section").each(function() {
   var thisEl = $(this)
   var elementTop = $(this).offset().top
  
   $(window).scroll(function() {
     var scroll = $(window).scrollTop()
     if(scroll >= elementTop - 150 ){       
       $(thisEl).addClass("is-active")     
       console.log("match")
     }else{
        $(thisEl).removeClass("is-active")
     }
   })


   
  console.log(" OFFSET "  +  $(this).offset().top )

   
 })

 



